import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BannerSlider from "views/BannerSlider";
import IndexNavbar from "components/Navbars/IndexNavbar";
import Footer from "components/Footers/Footer";
import FooterSmallNew from "components/Footers/FooterSmallNew";
import bgfish from "assets/img/bgfish.jpg";
import octopus from "assets/img/icon/octopus.png";
import fish from "assets/img/icon/fish.png";
import crab from "assets/img/icon/crab.png";
import SliderSmall from "views/Slider";
import aboutfish from "assets/img/aboutfish.jpeg";
import weoffer from "assets/img/weoffer.png";
import greymullet from "assets/img/fish/greymullet.0a34eaafe4ebb158034b.webp";
import redmullet from "assets/img/fish/redmullet.6798065c843c1429e388.webp";
import seabream from "assets/img/fish/seabream.jpg";
import bluefintunagg from "assets/img/fish/bluefintunagg.jpg";
import whitelegshrimp from "assets/img/fish/whitelegshrimp.jpg";
import redscorpionfish from "assets/img/fish/redscorpionfish.jpg";
import thon from "assets/img/fish/thon.882d7a06536a71892c1e.webp";
import squid from "assets/img/fish/squid.cc9095ee3226c9b26b71.webp";
import seabass from "assets/img/fish/seabass.jpg";
import octopuss from "assets/img/fish/octopuss.jpg";
import whitefish from "assets/img/icon/whitefish.png";
import contactus from "assets/img/contactus.jpg";
import message from "assets/img/icon/message.png";
import firstname from "assets/img/icon/firstname.png";
import email from "assets/img/icon/email.png";
import phonenumber from "assets/img/icon/phonenumber.png";
import squidimg from "assets/img/squidimg.png";
import shrimpsimg from "assets/img/shrimpsimg.jpeg";
import redmulletimg from "assets/img/redmulletimg.jpg";
import greymulletimg from "assets/img/greymulletimg.jpg";
import thonimg from "assets/img/thonimg.jpg";
import newimage from "assets/img/newimage.webp";
import homeicon1 from "assets/img/homeicon1.png";
import homeicon2 from "assets/img/homeicon2.png";
import star from "assets/img/star.png";
import aboutuspage from "assets/img/aboutuspage.jpg";

// french translatin import statements start
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";
import ContactForm from "about/aboutpage/ContactForm";
// french translatin import statements end

const Homepage = () => {
  // french translatin import statements
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();
  // french translatin import statements end

  //Slider
  const settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // 4 tab
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  // counting the numbers
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const sectionRef = useRef(null);
  const startedRef = useRef(false);

  const animateCount = (target, setter, duration, isMillion = false) => {
    let start = 0;
    const increment = target / (duration / 10);

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target;
        clearInterval(timer);
      }
      setter(Math.ceil(start));
    }, 10);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !startedRef.current) {
          animateCount(100, setCount1, 2500, true); // 100 for 100M+
          animateCount(150, setCount2, 2500); // 150 for 150+
          animateCount(100, setCount3, 2500);
          startedRef.current = true;
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  /* scrolldown slowly coming animation start */

  const sections = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target); // Stop observing the section once it's animated
          }
        });
      },
      { threshold: 0.4 }
    );

    sections.current.forEach((section) => {
      if (section && section instanceof Element) {
        observer.observe(section);
      }
    });

    const handleScroll = debounce(() => {
      sections.current.forEach((section) => {
        if (section && section instanceof Element) {
          observer.observe(section);
        }
      });
    }, 100);

    window.addEventListener("scroll", handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  /* scrolldown slowly coming animation end */

  return (
    <section className="overflow-hidden">
      <IndexNavbar />
      <BannerSlider />

      <section
        ref={(el) => sections.current.push(el)}
        style={{
          // backgroundColor: "#f5f5f5",
          //backgroundColor: "rgb(0 149 207 / 7%)",//
          backgroundSize: "cover",
        }}
        className="animate-on-scroll"
      >
        <div className="container mx-auto overflow-hidden px-4 xl:py-16 xl:px-12 lg:px-12 lg:py-8 py-6">
          <p className="uppercase banner-font text-sm text-md font-semibold text-center">
            {t("homecontent1")}
          </p>
          <h1 className="font-semibold uppercase banner-font text-black pt-1 xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center">
            {t("homecontent2")}{" "}
            <span className="text-md">{t("homecontent3")}</span>
          </h1>
          <div className="grid md:grid-cols-2 grid-cols-1 xl:pt-8 md:pt-8 pt-4 xl:px-12 items-center">
            <div className="z-2 xl:ml-0 xl:mr-4">
              <div className="bg-dark border-l xl:p-12 md:p-8 p-8 rounded-xl">
                <div className="text-left">
                  <h1 className="xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-white banner-font">
                    {t("homecontent4")}
                  </h1>
                  <p className="xl:pt-2 md:pt-4 pt-2 xl:text-para text-justify text-base text-white banner-font">
                    {t("homecontent5")}
                  </p>
                  <a href="/about-us">
                    <button className="md:mt-4 mt-4 text-white uppercase text-xs banner-font border-white px-6 py-2 onhovernew">
                      {t("homecontent6")}
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div className="xl:-ml-32 lg:-ml-32 md:-ml-20 md:mt-0 mt-4">
              <img
                src={aboutfish}
                className="xl:h-maxnew rounded-xl lg:h-maxnew md:h-320 xl:w-12/12 lg:w-12/12"
              />
            </div>
          </div>
        </div>
      </section>

      {/* <section
        ref={(el) => sections.current.push(el)}
        style={{
          position: "relative",
          backgroundImage: `url(${bghome})`,
          backgroundAttachment: "fixed",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="animate-on-scroll xl:h-450 lg:h-300 md:h-300 justify-center text-white"
      >
        <div className="">
          <div className="container mx-auto overflow-hidden hometext xl:px-24 px-4">
            <div className="grid md:grid-cols-2 ">
              <div className="text-left bg-dark-blue xl:p-16">
                <h1 className="banner-font text-white xl:pt-16 font-extrabold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
                  WE OFFER FIRST CLASS SEA FOOD
                </h1>
                <p className="pt-2 xl:pt-2 text-white xl:mb-18 banner-font xl:text-lg text-lg">
                  We guarantee you the best seafood, delivered daily to our
                  dock, prepared to your liking. Our focus is on serving the
                  absolute freshest fish and seafood.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/*} <section
        ref={(el) => sections.current.push(el)}
        style={{
          position: "relative",
          backgroundImage: `url(${weoffer})`,
          // backgroundAttachment: "fixed",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          // backgroundRepeat: "no-repeat",
        }}
        className="animate-on-scroll xl:h-400 lg:h-300 md:h-300 h-280 justify-center text-white"
      >
        <div className="container mx-auto overflow-hidden hometext xl:px-24 px-4 md:pt-0 pt-2">
          <div className="center-items">
            <h1 className="xl:pt-24 lg:pt-16 md:pt-12 uppercase font-semibold banner-font text-dark-blue pt-1 xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center">{t("homecontent7")}
              
            </h1>
            <p className="xl:px-68 lg:px-52 md:px-28 pt-2 xl:pt-2 text-dark-blue xl:mb-18 banner-font xl:text-lg text-lg xl:headlineheightt lg:headlineheightt md:headlineheightt">{t("homecontent8")}
              
            </p>
          </div>
        </div>
      </section>*/}

      <section
        ref={(el) => sections.current.push(el)}
        style={{
          backgroundColor: "rgb(0 149 207 / 7%)",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="animate-on-scroll"
      >
        <div className="container mx-auto overflow-hidden hometext xl:px-12 xl:py-12 md:py-12 py-8 px-4">
          <p className="uppercase banner-font text-sm font-semibold text-center">
            {t("homecontent9")}
          </p>
          <h1 className="uppercase font-semibold banner-font text-black pt-1 xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center">
            {t("homecontent11")}{" "}
            <span className="text-md">{t("homecontent10")}</span>
          </h1>
          <div className="grid md:grid-cols-5 grid-cols-2 gap-4 xl:mt-8 xl:px-12 lg:px-4 md:px-0 mt-8">
            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={bluefintunagg} className="team-memberr-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent12")}
                  </h1>
                </div>
              </div>
            </div>

            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={thonimg} className="team-memberr1-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent13")}
                  </h1>
                </div>
              </div>
            </div>
            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={redscorpionfish} className="team-memberr-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent14")}
                  </h1>
                </div>
              </div>
            </div>

            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={greymulletimg} className="team-memberr2-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent15")}
                  </h1>
                </div>
              </div>
            </div>
            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={redmulletimg} className="team-memberr2-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent16")}
                  </h1>
                </div>
              </div>
            </div>
            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={seabream} className="team-memberr-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent17")}
                  </h1>
                </div>
              </div>
            </div>
            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={octopuss} className="team-memberr-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent18")}
                  </h1>
                </div>
              </div>
            </div>
            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={seabass} className="team-memberr-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent19")}
                  </h1>
                </div>
              </div>
            </div>
            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={squidimg} className="team-memberr2-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent20")}
                  </h1>
                </div>
              </div>
            </div>
            <div className="team-memberr cursor-pointer center-items">
              <div className="team-memberr-inner">
                <img src={shrimpsimg} className="team-memberr2-image" />
                <div className="team-memberr-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("homecontent21")}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="center-items">
            <a href="/products">
              <button className="mt-8 text-blue-dark border-dark-blue onhover uppercase text-xs banner-font font-semibold px-6 py-2 ">
                {t("homecontent22")}
              </button>
            </a>
          </div>
        </div>
      </section>

      <section
        ref={(el) => sections.current.push(el)}
        style={{
          // backgroundImage: `url(${crab2})`,
          backgroundColor: "rgb(22, 9, 53)",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="animate-on-scroll"
      >
        <div className="">
          <div className="container mx-auto overflow-hidden hometext xl:px-16 xl:py-16 md:py-12 py-8 px-4">
            <div className="center-items">
              <p className="uppercase banner-font text-sm text-white font-semibold text-center">
                {t("homecontent23")}
              </p>
              <div className="xl:block lg:block md:block hidden">
                <h1 className="uppercase font-semibold banner-font text-white xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center pt-1">
                  {" "}
                  {t("homecontent24")}
                </h1>
                <h1 className="uppercase font-semibold banner-font text-white xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center ">
                  {" "}
                  {t("homecontent25")}
                </h1>
              </div>
              <div className="xl:hidden lg:hidden md:hidden block">
                <h1 className="uppercase font-semibold banner-font text-white xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center pt-1">
                  {t("homecontent26")}
                </h1>
              </div>
            </div>
            <div className="grid md:grid-cols-4 grid-cols-2 xl:gap-16 xl:mt-8 xl:px-new lg:px-52 md:px-32 mt-8">
              <a href="/products">
                <div className="rotate-container">
                  <div className="border-white xl:p-4 p-4  cursor-pointer center-items">
                    <img
                      src={octopus}
                      className="xl:w-12 lg:w-12 w-8 rotate-image"
                    />
                  </div>
                  <h3 className="text-white xl:mt-8 mt-2 text-center">●</h3>
                  <h2 className="banner-font font-semibold text-center xl:mt-2 mt-2 text-white xl:text-para">
                    {t("homecontent27")}
                  </h2>
                </div>
              </a>
              <a href="/products">
                <div className="rotate-container">
                  <div className="border-white xl:p-4 p-4 cursor-pointer center-items">
                    <img
                      src={whitefish}
                      className="xl:w-12 lg:w-12 w-8 rotate-image"
                    />
                  </div>
                  <h3 className="text-white xl:mt-8 mt-2 text-center">●</h3>
                  <h2 className="banner-font font-semibold text-center xl:mt-2 mt-2 text-white xl:text-para">
                    {t("homecontent28")}
                  </h2>
                </div>
              </a>
              <a href="/products">
                <div className="rotate-container md:mt-0 mt-8">
                  <div className="border-white xl:p-4 p-4  cursor-pointer center-items">
                    <img
                      src={crab}
                      className="xl:w-12 lg:w-12 w-8 rotate-image"
                    />
                  </div>
                  <h3 className="text-white xl:mt-8 mt-2 text-center">●</h3>
                  <h2 className="banner-font font-semibold text-center xl:mt-2 mt-2 text-white xl:text-para">
                    {t("homecontent29")}
                  </h2>
                </div>
              </a>
              <a href="/products">
                <div className="rotate-container md:mt-0 mt-8">
                  <div className="border-white xl:p-4 p-4  cursor-pointer center-items">
                    <img
                      src={fish}
                      className="xl:w-12 lg:w-12 w-8 rotate-image"
                    />
                  </div>
                  <h3 className="text-white xl:mt-8 mt-2 text-center">●</h3>
                  <h2 className="banner-font font-semibold text-center xl:mt-2 mt-2 text-white xl:text-para">
                    {t("homecontent30")}
                  </h2>
                </div>
              </a>
            </div>
            <div className="center-items xl:mt-12 lg:mt-12 mt-8">
              <div className="flex">
                {/*} <button className="text-white uppercase font-semibold text-xs banner-font border-white px-6 py-2 onhovernew">{t("homecontent31")}
                  
                </button>*/}
                <a href="/contact-us">
                  <button className="xl:ml-4 ml-4 text-white font-semibold uppercase text-xs banner-font border-white px-6 py-2 onhoverneww">
                    {t("homecontent32")}
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*<SliderSmall />*/}

      <section className="xl:block lg:block md:block sm:hidden hidden container mx-auto xl:px-20 xl:pb-16 xl:mt-16 lg:mt-16 lg:pb-16 px-4 mt-12 pb-12">
        <h1 className="uppercase font-semibold banner-font text-dark text-center text-3xl xl:text-head1 lg:text-head1 md:text-head1 sm:text-2xl">
          {t("homecontent46")}
        </h1>
        <p className="text-lg text-grayBlue text-center mt-2">
          {t("homecontent47")}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-8 mt-12">
          <div>
            <div className="center-items content-box1 text-center p-4">
              <h1 className="xl:text-5xl text-3xl font-bold text-dark">
                {t("homecontent48")}
              </h1>
              <h1 className="text-2xl font-semibold pt-2 text-dark">
                {t("homecontent49")}
              </h1>
              <p className="text-base pt-2 text-grayBlue">
                {t("homecontent50")}.
              </p>
            </div>
          </div>
          <div>
            <div className="center-items content-box1 text-center p-4">
              <h1 className="xl:text-5xl text-3xl font-bold text-dark">
                {t("homecontent51")}
              </h1>
              <h1 className="text-2xl font-semibold pt-2 text-dark">
                {t("homecontent52")}
              </h1>
              <p className="text-base pt-2 text-grayBlue">
                {t("homecontent53")}
              </p>
            </div>
          </div>
          <div>
            <div className="center-items  text-center p-4 xl:mt-0 lg:mt-0 md:mt-8">
              <h1 className="xl:text-5xl text-3xl font-bold text-dark">
                {t("homecontent54")}
              </h1>
              <h1 className="text-2xl font-semibold pt-2 text-dark">
                {t("homecontent55")}
              </h1>
              <p className="text-base pt-2 text-grayBlue">
                {t("homecontent56")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/*mobile view*/}
      <section className="xl:hidden lg:hidden md:hidden sm:block block container mx-auto  px-4 mt-12 pb-12">
        <h1 className="uppercase font-semibold banner-font text-dark text-center text-3xl ">
          Our priority is quality
        </h1>
        <p className="text-lg text-grayBlue text-center mt-2">
          We attach the quality of our products and the satisfaction of our
          customers.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-1  gap-8 ">
          <div>
            <div className="center-items  text-center p-4">
              <h1 className=" text-3xl font-bold text-dark">215</h1>
              <h1 className="text-2xl font-semibold pt-2 text-dark">
                Complete Projects
              </h1>
              <p className="text-base pt-2 text-grayBlue">
                Successfully accomplished all project with Innovation and
                Efficiency.
              </p>
            </div>
          </div>
          <div>
            <div className="center-items  text-center p-4">
              <h1 className=" text-3xl font-bold text-dark">123</h1>
              <h1 className="text-2xl font-semibold pt-2 text-dark">
                Expert Employees
              </h1>
              <p className="text-base pt-2 text-grayBlue">
                We have expertise in guaranteeing superior quality for each
                service.
              </p>
            </div>
          </div>
          <div>
            <div className="center-items  text-center p-4 ">
              <h1 className=" text-3xl font-bold text-dark">3245</h1>
              <h1 className="text-2xl font-semibold pt-2 text-dark">
                Satisfied Customers
              </h1>
              <p className="text-base pt-2 text-grayBlue">
                Improving our skills and expertise to meet your needs.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        ref={(el) => sections.current.push(el)}
        style={{
          backgroundImage: `url(${newimage})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="animate-on-scroll"
      >
        <div className="container xl:py-2 lg:py-2 md:py-2 py-2 mx-auto ">
          <div className="xl:pt-12 lg:pt-8 md:pt-8 pt-8 xl:px-24 lg:px-20 md:px-28 px-4 grid lg:grid-cols-2 md:grid-cols-1">
            <div></div>

            <div>
              <h1 className="text-center font-semibold px-2 text-white xl:text-head1 lg:text-head1 md:text-head1 text-head1 uppercase md:text-2xl text-lg banner-font">
                {t("homecontent37")}
              </h1>
              <div className="xl:pt-8 xl:pb-8 lg:pt-4 lg:pb-8 pb-8 pt-4">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FooterSmallNew />
    </section>
  );
};

export default Homepage;
